import {handleActions} from 'redux-actions'

import {setCatalogoBtaEmpresas, setCatalogosAPIndividual,} from "../actionsMex/aCatalogos";


const handleSetCatalogosAPIndividual = (state, {payload}) => {
  return {
    ...state,
    catalogoAPIndividual: payload
  }
}

export const CatalogosMex = handleActions(
  {
    [setCatalogoBtaEmpresas]: (state, action) => ({...state, setCatalogoBtaEmpresas: action.payload}),
    [setCatalogosAPIndividual]: handleSetCatalogosAPIndividual
  },
  {
    setCatalogoBtaEmpresas: undefined
  }
);
